import React from 'react'

const IconWaitApprove= ({fillColor,style}) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" className={'icon ' + fillColor} style={style} viewBox="0 -960 960 960" >
      <path d="M452-160ZM160-80v-80h80v-120q0-61 28.5-114.5T348-480q-51-32-79.5-85.5T240-680v-120h-80v-80h640v80h-80v120q0 48-18 92t-51 77q-38 10-71 29t-60 47q-10-2-19.5-3.5T480-440q-66 0-113 47t-47 113v120h132q7 22 16.5 42T491-80H160Zm433-487q47-47 47-113v-120H320v120q0 66 47 113t113 47q66 0 113-47ZM578.5-98.5Q520-157 520-240t58.5-141.5Q637-440 720-440t141.5 58.5Q920-323 920-240T861.5-98.5Q803-40 720-40T578.5-98.5ZM480-800Zm212 650 142-142-30-30-112 112-56-56-30 30 86 86Z"/>
    </svg>
  )
}
export default IconWaitApprove 